<template>
    <footer style="background-color:#f3f4f8">
        <div class="py-0 border-top border-bottom border-gray-400" style="background-color:#fff;">
            <v-container>
                <ul class="list-unstyled d-flex flex-wrap ps-0 justify-center">
                    <li
                        v-for="(link, label, i) in $optional('data.footer_menu')"
                        :key="i"
                        :class="[ 'py-2 pe-4 pe-md-7', { 'ps-md-3 ps-md-7': i !== 0 }]"
                    >
                        <dynamic-link :to="link" append-class="text-reset fw-600 opacity-80">{{ label }}</dynamic-link>
                    </li>
                </ul>
            </v-container>
        </div>
        <v-container class="pt-8 pb-14 pb-md-10 pb-lg-0">
            <v-row>
                <v-col class="" cols="12" sm="8" md="6" lg="2">
                    <div class="pb-7 border-gray-800 mb-6">
                        <img :src="data.footer_logo" class="mw-100" />
                    </div>
                </v-col>
                <v-col
                    class="mb-5"
                    lg="5"
                    cols="12"
                    offset-lg="1"
                >
                    <ul class="list-unstyled ps-0 fs-13 mb-3 opacity-80">
                        <li class="py-1 fs-15 fw-700">{{ $optional( 'data.company_info?.company_name') }}</li>
                        <li class="py-1">본사 주소 : {{ $optional( "data.contact_info?.contact_address" ) }} <span class="fs-11 px-2">|</span> 대표이사 : {{ $optional( 'data.company_info?.ceo_name') }}</li>
                        <li class="py-1">사업자번호 : {{ $optional( 'data.company_info?.biz_number') }} <span class="fs-10 px-2">|</span> 통신판매번호 : {{ $optional( 'data.company_info?.online_sales_license_number') }}</li>
                        <li class="py-1">개인정보관리 책임자 : {{ $optional( 'data.company_info?.privacy_manager') }} <span class="fs-11 px-2">|</span> 이메일 : {{ $optional( "data.contact_info?.contact_email" ) }}</li>
                        <li class="py-1">연락처 : {{ $optional( "data.contact_info?.contact_phone")}} <span class="fs-11 px-2">|</span> 팩스 : {{ $optional( "data.contact_info?.contact_fax" ) }}</li>   
                        <li class="py-1">웹하드 : {{ $optional( 'data.company_info?.webhard_id') }} / {{ $optional( 'data.company_info?.webhard_pw') }}</li>
                    </ul>
                </v-col>
                <v-col class="mb-5" lg="4" cols="12">
                    <ul class="list-unstyled ps-0 fs-13 mb-3">
                        <li class="py-1 fs-15 fw-700" v-if="data.contact_info?.factory1_address || data.contact_info?.factory1_address">공장</li>
                        <li class="py-1" v-if="data.contact_info?.factory1_address">1공장 : {{ $optional( "data.contact_info?.factory1_address" ) }}</li>
                        <li class="py-1 mb-2" v-if="data.contact_info?.factory2_address">2공장 : {{ $optional( "data.contact_info?.factory2_address" ) }}</li>
                    </ul>
                </v-col>
            </v-row>
            <v-row class="py-2">
                <v-col cols="12">
                    <div v-html="$optional('data.copyright_text')" class="text-center lh-1 fs-13" ></div>
                </v-col>
            </v-row>
        </v-container>
    </footer>
</template>

<script>
export default {
    props: {
        loading: { type: Boolean, default: false },
        data: {
            type: Object,
            default: {},
        },
    },
    computed: {

    },
    methods: {

    },
};
</script>
